let dirPath = 'static/games/page025_game1';

let configGame = {
  removeInCorrects: true,
  correctBlock: false,
  //autoCheckAllCorrect: true,
  removeAllFromBadTarget: true,
  rulesGame: {
    itemsConfig: {
      block: true,
    },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 't0',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '00',
            correct: [{ idGroup: 't0', idItem: 'legend', idHook: 'hook0' }],
          },
          {
            idGroup: 'source',
            idItem: '01',
            correct: [{ idGroup: 't0', idItem: 'legend', idHook: 'hook1' }],
          },
          {
            idGroup: 'source',
            idItem: '02',
            correct: [{ idGroup: 't0', idItem: 'legend', idHook: 'hook2' }],
          },
        ],
      },
      {
        idGroup: 't1',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source1',
            idItem: '00',
            correct: [{ idGroup: 't1', idItem: 'legend', idHook: 'hook0' }],
          },
          {
            idGroup: 'source1',
            idItem: '01',
            correct: [{ idGroup: 't1', idItem: 'legend', idHook: 'hook1' }],
          },
          {
            idGroup: 'source1',
            idItem: '02',
            correct: [{ idGroup: 't1', idItem: 'legend', idHook: 'hook2' }],
          },
        ],
      },
      {
        idGroup: 't2',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source2',
            idItem: '00',
            correct: [{ idGroup: 't2', idItem: 'legend', idHook: 'hook0' }],
          },
          {
            idGroup: 'source2',
            idItem: '01',
            correct: [{ idGroup: 't2', idItem: 'legend', idHook: 'hook1' }],
          },
          {
            idGroup: 'source2',
            idItem: '02',
            correct: [{ idGroup: 't2', idItem: 'legend', idHook: 'hook2' }],
          },
        ],
      },
      {
        idGroup: 't3',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source3',
            idItem: '00',
            correct: [{ idGroup: 't3', idItem: 'legend', idHook: 'hook0' }],
          },
          {
            idGroup: 'source3',
            idItem: '01',
            correct: [{ idGroup: 't3', idItem: 'legend', idHook: 'hook1' }],
          },
          {
            idGroup: 'source3',
            idItem: '02',
            correct: [{ idGroup: 't3', idItem: 'legend', idHook: 'hook2' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: {
        margin: { left: 5, bottom: 5 },
      },
      background: {
        color: 'transparent',
        text: { size: '28px', textAlign: 'center', textBaseline: 'middle', font: 'Myriad Pro' },
      },
    },
    groups: [
      {
        idGroup: 't0',
        background: {
          color: 'rgba(255, 255, 255, 0.01)',
          image: { src: dirPath + '/img/00.jpg' },
          //     color: 'pink',
        },
        positions: {
          type: 'absolute',
          pos: { x: 0, y: 0, height: 400, width: 800 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: '#f2f2f2',
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 53, width: 190 },
                },
                items: [
                  {
                    id: 'hook0',
                    background: {
                      color: '#f2f2f2',
                      text: { val: 'Roboty w szpitalu', offset: { x: -228 }, size: '28px', font: 'Myriad Pro' },
                    },
                    positions: { pos: { x: 228, y: 345, height: 53, width: 190 } },
                  },
                  {
                    id: 'hook1',
                    background: {
                      color: '#f2f2f2',
                    },
                    positions: { pos: { x: 419, y: 345, height: 53, width: 190 } },
                  },
                  {
                    id: 'hook2',
                    background: {
                      color: '#f2f2f2',
                    },
                    positions: { pos: { x: 610, y: 345, height: 53, width: 190 } },
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        positions: {
          type: 'absolute',
          pos: { x: 540, y: 0 },
          autoFit: true,
        },
        itemsConfig: {
          positions: {
            columns: 1,
            pos: { height: 53, width: 190 },
            margin: { top: 10 },
          },
          background: {
            color: '#f2f2f2',
          },
        },
        items: [
          {
            id: '00',
            background: {
              text: { val: 'pomagają' },
            },
          },
          {
            id: '01',
            background: {
              text: { val: 'leczyć' },
            },
          },
          {
            id: '02',
            background: {
              text: { val: 'chorych.' },
            },
          },
        ],
      },
      //
      {
        idGroup: 't1',
        background: {
          color: 'rgba(255, 255, 255, 0.01)',
          image: { src: dirPath + '/img/03.jpg' },
          //     color: 'pink',
        },
        positions: {
          type: 'absolute',
          pos: { x: 0, y: 420, height: 400, width: 800 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: '#f2f2f2',
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 53, width: 190 },
                },
                items: [
                  {
                    id: 'hook0',
                    background: {
                      color: '#f2f2f2',
                      text: { val: 'Roboty w fabryce', offset: { x: -228 }, size: '28px', font: 'Myriad Pro' },
                    },
                    positions: { pos: { x: 228, y: 345, height: 53, width: 190 } },
                  },
                  {
                    id: 'hook1',
                    background: {
                      color: '#f2f2f2',
                    },
                    positions: { pos: { x: 419, y: 345, height: 53, width: 190 } },
                  },
                  {
                    id: 'hook2',
                    background: {
                      color: '#f2f2f2',
                    },
                    positions: { pos: { x: 610, y: 345, height: 53, width: 190 } },
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'source1',
        positions: {
          type: 'absolute',
          pos: { x: 540, y: 420 },
          autoFit: true,
        },
        itemsConfig: {
          positions: {
            columns: 1,
            pos: { height: 53, width: 190 },
            margin: { top: 10 },
          },
          background: {
            color: '#f2f2f2',
          },
        },
        items: [
          {
            id: '00',
            background: {
              text: { val: 'pomagają' },
            },
          },
          {
            id: '01',
            background: {
              text: { val: 'produkować' },
            },
          },
          {
            id: '02',
            background: {
              text: { val: 'samochody.' },
            },
          },
        ],
      },
      //
      {
        idGroup: 't2',
        background: {
          color: 'rgba(255, 255, 255, 0.01)',
          image: { src: dirPath + '/img/02.jpg' },
          //     color: 'pink',
        },
        positions: {
          type: 'absolute',
          pos: { x: 1020, y: 0, height: 400, width: 800 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: '#f2f2f2',
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 53, width: 190 },
                },
                items: [
                  {
                    id: 'hook0',
                    background: {
                      color: '#f2f2f2',
                      text: { val: 'Roboty w szkole', offset: { x: -228 }, size: '28px', font: 'Myriad Pro' },
                    },
                    positions: { pos: { x: 228, y: 345, height: 53, width: 190 } },
                  },
                  {
                    id: 'hook1',
                    background: {
                      color: '#f2f2f2',
                    },
                    positions: { pos: { x: 419, y: 345, height: 53, width: 190 } },
                  },
                  {
                    id: 'hook2',
                    background: {
                      color: '#f2f2f2',
                    },
                    positions: { pos: { x: 610, y: 345, height: 53, width: 190 } },
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'source2',
        positions: {
          type: 'absolute',
          pos: { x: 920 + 640, y: 0 },
          autoFit: true,
        },
        itemsConfig: {
          positions: {
            columns: 1,
            pos: { height: 53, width: 190 },
            margin: { top: 10 },
          },
          background: {
            color: '#f2f2f2',
          },
        },
        items: [
          {
            id: '00',
            background: {
              text: { val: 'uczą' },
            },
          },
          {
            id: '01',
            background: {
              text: { val: 'dzieci' },
            },
          },
          {
            id: '02',
            background: {
              text: { val: 'programowania.' },
            },
          },
        ],
      },
      //
      {
        idGroup: 't3',
        background: {
          color: 'rgba(255, 255, 255, 0.01)',
          image: { src: dirPath + '/img/01.jpg' },
          //     color: 'pink',
        },
        positions: {
          type: 'absolute',
          pos: { x: 1020, y: 420, height: 400, width: 800 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: '#f2f2f2',
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 53, width: 190 },
                },
                items: [
                  {
                    id: 'hook0',
                    background: {
                      color: '#f2f2f2',
                      text: { val: 'Roboty w kosmosie', offset: { x: -228 }, size: '28px', font: 'Myriad Pro' },
                    },
                    positions: { pos: { x: 228, y: 345, height: 53, width: 190 } },
                  },
                  {
                    id: 'hook1',
                    background: {
                      color: '#f2f2f2',
                    },
                    positions: { pos: { x: 419, y: 345, height: 53, width: 190 } },
                  },
                  {
                    id: 'hook2',
                    background: {
                      color: '#f2f2f2',
                    },
                    positions: { pos: { x: 610, y: 345, height: 53, width: 190 } },
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'source3',
        positions: {
          type: 'absolute',
          pos: { x: 920 + 640, y: 420 },
          autoFit: true,
        },
        itemsConfig: {
          positions: {
            columns: 1,
            pos: { height: 53, width: 190 },
            margin: { top: 10 },
          },
          background: {
            color: '#f2f2f2',
          },
        },
        items: [
          {
            id: '00',
            background: {
              text: { val: 'pomagają' },
            },
          },
          {
            id: '01',
            background: {
              text: { val: 'naukowcom' },
            },
          },
          {
            id: '02',
            background: {
              text: { val: 'badać planetę.' },
            },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  // isDev: true,
  //   defaultConfig: dirPath + '/defaultConfig.json',
  realHeight: 850,
  //   realWidth: 1820,
  mainImage: {
    imagePath: 'informatyka/games/page025_game1/img/plansza.png',
    pos: {
      x: 0,
      y: 0,
    },
    width: 1920,
    height: 1080,
  },
  cssStyle: {
    overflow: 'hidden',
  },
  configGame: configGame,
};

export default dataConfig;
